import type { Player } from "../../../common/types.ts";
import { PLAYER } from "../../../common/constants.ts";
import { g } from "../../util/index.ts";
import moodComponents from "../player/moodComponents.ts";
import { MIN_DISSATISFACTION_AGE } from "../player/minorsSatisfaction.ts";

const labels: Record<string, string> = {
	marketSize: "Market size",
	facilities: "Facilities",
	teamPerformance: "Team performance",
	hype: "Team outlook",
	loyalty: "Loyalty",
	trades: "Teammates traded",
	playingTime: "Playing time",
	rookieContract: "Rookie contract",
	relatives: "Family",
	difficulty: "League difficulty",
};
const traitLabels: Record<string, string> = {
	L: "Loyal",
	W: "Winning",
	F: "Fame",
	$: "Money",
};
export const tradePlayerContext = async (p: Player) => {
	const owner = p.tid === PLAYER.MINORS ? p.minorTid : p.tid;
	const age = g.get("season") - p.born.year;
	const components =
		owner !== undefined && owner >= 0
			? await moodComponents(p, owner)
			: undefined;
	const reasons: { text: string; amount: number }[] = [];
	for (const [key, value] of Object.entries(components ?? {})) {
		if (key === "custom" && Array.isArray(value)) reasons.push(...value);
		else if (typeof value === "number" && value !== 0)
			reasons.push({ text: labels[key] ?? key, amount: value });
	}
	const score = reasons.reduce((sum, r) => sum + r.amount, 0);
	const strongest = [...reasons].sort((a, b) =>
		score < 0 ? a.amount - b.amount : b.amount - a.amount,
	)[0];
	return {
		traits: g.get("playerMoodTraits")
			? p.moodTraits.map((t) => traitLabels[t] ?? t).join(" · ")
			: "",
		score,
		label: score <= -2 ? "Unhappy" : score >= 2 ? "Happy" : "Neutral",
		reason: strongest?.text ?? "No strong concern",
		opportunityProtected: age < MIN_DISSATISFACTION_AGE,
	};
};
